import React from 'react';
import { useStyletron } from 'baseui';
type propT = {
  strokeColor?: string;
};
const Icon = (props: propT) => {
  const [_, theme] = useStyletron();
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" preserveAspectRatio="xMidYMid meet">
      <line x1="2.4" y1="20.6" x2="18" y2="20.6" stroke={props.strokeColor ? props.strokeColor : 'currentColor'} strokeWidth="2" />
      <line x1="4.09289" y1="19.6929" x2="16.0929" y2="7.69289" stroke={props.strokeColor ? props.strokeColor : 'currentColor'} strokeWidth="2" />
      <line y1="-1" x2="15.3108" y2="-1" transform="matrix(-3.99275e-09 -1 -0.999958 0.00915707 2.4 21.3108)" stroke={props.strokeColor ? props.strokeColor : 'currentColor'} strokeWidth="2" />
      <circle cx="3.6" cy="3.6" r="3.6" fill={props.strokeColor ? props.strokeColor : 'currentColor'} />
      <circle cx="3.6" cy="3.6" r="1.54286" fill={theme.colors.backgroundSecondary} />
      <circle cx="18" cy="6" r="3.6" fill={props.strokeColor ? props.strokeColor : 'currentColor'} />
      <circle cx="18" cy="6" r="1.54286" fill={theme.colors.backgroundSecondary} />
      <circle cx="20.4" cy="20.4" r="3.6" fill={props.strokeColor ? props.strokeColor : 'currentColor'} />
      <circle cx="20.4" cy="20.4" r="1.54286" fill={theme.colors.backgroundSecondary} />
    </svg>;
};
export default Icon;